export default __webpack_public_path__ + "static/media/approved_icon.51ef1ff9.svg";